import React from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import { Box, Button } from '@mui/material';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FormPreviewPublication from './components/form-preview-publcation';
import PreviewPublication from './components/preview-publication';
import { useOfficialDiaryPublicationController } from './context/official-diary-publication-controller';
import { useOfficialDiaryPublicationState } from './context/official-diary-publication-context';
import PageHeader from '../../../components/page-header';

export function OfficialDiaryPublicationComponent() {
    const {
        steps,
        isLastStep,
        setRequestPreviewParameters,
        setFilesUpload,
        handleNext,
        handleBack,
        requestConfirmPublicationRequest
    } = useOfficialDiaryPublicationController();

    const {
        activeStep,
        completed,
        files,
        previewPublicationRequest,
        previewPublicationResponse
    } = useOfficialDiaryPublicationState();

    const renderContent = () => {
        if (activeStep === 0) {
            return (
                <FormPreviewPublication
                    props={{
                        previewPublicationRequest: previewPublicationRequest,
                        setPreviewPublicationRequest: setRequestPreviewParameters,
                        setFilesUpload: setFilesUpload,
                        files: files
                    }}
                />
            );
        } else if (activeStep === 1) {
            return (
                <PreviewPublication
                    props={{
                        previewPublicationResponse
                    }}
                />
            );
        } else if (activeStep === 2) {
            return (
                <PreviewPublication
                    props={{
                        previewPublicationResponse
                    }}
                />
            );
        }
    };

    const confirmPublication = () => {
        requestConfirmPublicationRequest();
    };

    return (
        <React.Fragment>
            <Grid item xs={12} md={12} lg={12}>
                <PageHeader
                    title="Criar Publicação no Diário Oficial"
                    subtitle="Configure e publique uma nova edição do Diário Oficial"
                    breadcrumbs={[
                        { label: 'SDP', href: '/sdp' },
                        { label: 'Diário Oficial', href: '/sdp/diario-oficial' },
                        { label: 'Nova Publicação' }
                    ]}
                />
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
                <Paper
                    sx={{
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                    elevation={3}
                >
                    <Grid item sx={{ mb: 5 }} xs={12} md={12} lg={12}>
                        <Stepper nonLinear activeStep={activeStep}>
                            {steps.map((label, index) => (
                                <Step key={label} completed={completed[index]}>
                                    <StepButton color="inherit">
                                        {label}
                                    </StepButton>
                                </Step>
                            ))}
                        </Stepper>
                    </Grid>
                    {renderContent()}
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                        <Button
                            variant="contained"
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            sx={{ mr: 1 }}
                            startIcon={<ArrowCircleLeftIcon />}
                        >
                            Anterior
                        </Button>
                        <Box sx={{ flex: '1 1 auto' }} />
                        <Button
                            variant="contained"
                            onClick={() => { isLastStep() ? confirmPublication() : handleNext() }}
                            sx={{ mr: 1 }}
                            endIcon={isLastStep() ? <CheckCircleIcon /> : <ArrowCircleRightIcon />}
                        >
                            {isLastStep() ? 'Finalizar' : 'Próximo'}
                        </Button>
                    </Box>
                </Paper>
            </Grid>
        </React.Fragment>
    );
}
